var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invalid-feedback"},[(typeof _vm.errors === 'string')?_c('div',[_vm._v(" "+_vm._s(_vm.errors)+" ")]):_vm._l((_vm.errors),function(error,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(error)+" ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }